import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

import {
  IReverseConfig,
  IReverseConfigForm,
  IReverseConfigParameters
} from 'src/app/models/reverseConfig';
import { SnackbarService } from './../../../../services/snackbar.service';
import { ApiReverseConfigService } from './../../../../services/api/api-reverse-config.service';

@Component({
  selector: 'app-modal-estorno',
  templateUrl: './modal-estorno.component.html',
  styleUrls: ['./modal-estorno.component.scss']
})
export class ModalEstornoComponent implements OnInit {
  form!: FormGroup<IReverseConfigForm>;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      reverseConfig: IReverseConfig;
      reverseParameters: IReverseConfigParameters;
      type: 'default' | 'document';
    },
    private _dialogRef: MatDialogRef<ModalEstornoComponent>,
    private _reverseConfigService: ApiReverseConfigService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.form = new FormGroup<IReverseConfigForm>({
      Amount: new FormControl<number | null>(null, {
        nonNullable: true
      }),
      Bank: new FormControl<string>('', { nonNullable: true }),
      ContractStatus: new FormControl<string>('', { nonNullable: true }),
      BatchStatus: new FormControl<string>('', { nonNullable: true }),
      Channel: new FormControl<string>('', { nonNullable: true }),
      Days: new FormControl<number | null>(null, {
        nonNullable: true
      }),
      Document: new FormControl<string>('', { nonNullable: true }),
      HasDocument: new FormControl<boolean>(false, { nonNullable: true }),
      IsValue: new FormControl<boolean>(false, { nonNullable: true }),
      Paid: new FormControl<boolean>(true, { nonNullable: true }),
      Partial: new FormControl<boolean>(false, { nonNullable: true }),
      ReversalType: new FormControl<string>('', { nonNullable: true })
    });

    this.setValuesDefault();
    this.listenReversalTypeValue();
  }

  setValuesDefault(): void {
    if (this.data.reverseConfig) {
      this.form.patchValue(this.data.reverseConfig);
      this.form.controls['Document'].disable();
      this.form.controls['Bank'].disable();
      this.form.controls['Channel'].disable();

      let reverseValue: string = !this.data.reverseConfig.Partial
        ? 'integral'
        : this.data.reverseConfig.IsValue
        ? 'parcial (r$)'
        : 'parcial (%)';
      this.form.controls['ReversalType'].setValue(reverseValue);
      reverseValue === 'integral' && this.form.controls['Amount'].disable();
    }

    this.form.controls['HasDocument'].setValue(this.data.type === 'document');
  }

  listenReversalTypeValue(): void {
    this.form.controls['ReversalType'].valueChanges.subscribe({
      next: (response) => {
        switch (response) {
          case 'integral':
            this.form.controls['Amount'].setValue(100);
            this.form.controls['Amount'].disable();
            this.form.controls['IsValue'].setValue(false);
            this.form.controls['Partial'].setValue(false);
            break;

          case 'parcial (r$)':
            this.form.controls['Amount'].setValue(0);
            this.form.controls['Amount'].enable();
            this.form.controls['IsValue'].setValue(true);
            this.form.controls['Partial'].setValue(true);
            break;

          case 'parcial (%)':
            this.form.controls['Amount'].setValue(null);
            this.form.controls['Amount'].enable();
            this.form.controls['IsValue'].setValue(false);
            this.form.controls['Partial'].setValue(true);
            break;
        }
      }
    });
  }

  handleReverseConfig(): void {
    const reversalConfig = this.form.getRawValue() as IReverseConfig;
    reversalConfig.Days = Number(reversalConfig.Days);

    if (!!this.data.reverseConfig)
      reversalConfig.ReversalParameterId =
        this.data.reverseConfig.ReversalParameterId;

    let text: string = !!this.data.reverseConfig ? 'atualizada' : 'criada';

    this.saveReverseConfig(reversalConfig, text);
  }

  saveReverseConfig(reversalConfig: IReverseConfig, text: string): void {
    this._reverseConfigService.saveReverseConfig(reversalConfig).subscribe({
      next: (response) => {
        this._snackbarService.openSnackBar(
          `Configuração de estorno ${text} com sucesso!`,
          'success'
        );
        this._dialogRef.close({ reload: true, type: this.data.type });
      }
    });
  }
}
